import React, { useState } from 'react';
import PaymentVerificationModal from '../components/modals/PaymentVerificationModal';

const ModalTest = () => {
  const [showModal, setShowModal] = useState(true); // Set to true to show immediately
  const [error, setError] = useState(null);

  // Mock user details
  const mockUserDetails = {
    planId: 1, // or 2 for Plus plan
    planPrice: "1.00", // USD price
    planName: "Basic Plan", // or "Plus Plan"
    email: "barniebez1@gmail.com"
  };

  // Mock token
  const mockToken = "test-verification-token-123";

  // Mock handlers
  const handleSuccess = (paymentData) => {
    console.log('Payment success:', paymentData);
    setShowModal(false);
  };

  const handleError = (errorMessage) => {
    console.log('Payment error:', errorMessage);
    setError(errorMessage);
  };

  const handleHide = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
    setError(null);
  };

  return (
    <div className="container mt-5">
      <div className="text-center">
        <h2>Modal Testing</h2>
        <button 
          className="btn btn-primary mb-3" 
          onClick={handleShowModal}
        >
          Show Payment Modal
        </button>
        
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}
      </div>

      <PaymentVerificationModal
        show={showModal}
        onHide={handleHide}
        userDetails={mockUserDetails}
        token={mockToken}
        onSuccess={handleSuccess}
        onError={handleError}
      />
    </div>
  );
};

export default ModalTest;